<div class="backgroundLogin"></div>
<div class="container-recover">
  <mat-card class="recover-card">
    <img id="tower-img" class="login-logo" [src]="logoUrl" />
    <div *ngIf="!resetResult">
      <p class="title text-center">{{ 'k001955' | translate }}</p>
      <!-- Token: Create new password -->
      <p class="content text-left">
        {{ 'k001956' | translate }}
      </p>
      <!-- Token: You can choose a new password by completing the following fields -->
      <form [formGroup]="form" (ngSubmit)="sendPass()" class="form-recover">
        <mat-form-field>
          <input
            matInput
            name="password"
            placeholder="{{ 'k000002' | translate }}"
            [type]="hide ? 'password' : 'text'"
            formControlName="password"
            class="ipt-item"
            (keyup)="formValidation()"
          />
          <!-- Token: Password -->
          <mat-icon
            matSuffix
            (click)="hide = !hide"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide"
          >
            <fa-icon
              icon="{{ hide ? 'eye' : 'eye-slash' }}"
              size="xs"
            ></fa-icon>
          </mat-icon>
        </mat-form-field>
        <!--
        <div class="inputError w-100" *ngIf="f.password.dirty">
          <div *ngIf="passwordMinLength">{{ textMinLengthPass }}</div>
          <div *ngIf="passwordpattern">
            {{ 'k002071' | translate }}
          </div>
        </div>
        -->
        <mat-form-field>
          <input
            matInput
            name="password2"
            placeholder="{{ 'k001957' | translate }}"
            [type]="hide ? 'password' : 'text'"
            formControlName="password2"
            (keyup)="formValidation()"
            class="ipt-item"
          />
          <!-- Token: Confirm password -->
          <mat-icon
            matSuffix
            (click)="hide = !hide"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide"
          >
            <fa-icon
              icon="{{ hide ? 'eye' : 'eye-slash' }}"
              size="xs"
            ></fa-icon>
          </mat-icon>
        </mat-form-field>
        <!--
        <div class="inputError w-100" *ngIf="f.password2.dirty">
          <div *ngIf="password2MinLength">{{ textMinLengthPass }}</div>
          <div *ngIf="password2pattern">
            {{ 'k002071' | translate }}
          </div>
        </div>
        <div class="inputError w-100 mt-5" *ngIf="f.password2.dirty">
          <div *ngIf="noMatchPass">{{ 'k002072' | translate }}</div>
        </div>
        -->
        <!--Nuevo que todas las validaciones salgan al final del todo-->
        <div class="dataerror">
          <small>
            <fa-icon
              [hidden]="!errorMinLength"
              class="red"
              [icon]="['fal', 'circle-xmark']"
            ></fa-icon>
            <fa-icon
              [hidden]="errorMinLength"
              class="green"
              [icon]="['fal', 'circle-check']"
            ></fa-icon>
            {{ 'k002466' | translate }} </small
          ><br />
          <small>
            <fa-icon
              [hidden]="!errorUpcase"
              class="red"
              [icon]="['fal', 'circle-xmark']"
            ></fa-icon>
            <fa-icon
              [hidden]="errorUpcase"
              class="green"
              [icon]="['fal', 'circle-check']"
            ></fa-icon>
            {{ 'k002467' | translate }} </small
          ><br />
          <small>
            <fa-icon
              [hidden]="!errorDowncase"
              class="red"
              [icon]="['fal', 'circle-xmark']"
            ></fa-icon>
            <fa-icon
              [hidden]="errorDowncase"
              class="green"
              [icon]="['fal', 'circle-check']"
            ></fa-icon>
            {{ 'k002468' | translate }} </small
          ><br />
          <small>
            <fa-icon
              [hidden]="!errorDigi"
              class="red"
              [icon]="['fal', 'circle-xmark']"
            ></fa-icon>
            <fa-icon
              [hidden]="errorDigi"
              class="green"
              [icon]="['fal', 'circle-check']"
            ></fa-icon>
            {{ 'k002469' | translate }} </small
          ><br />
          <small>
            <fa-icon
              [hidden]="!errorChart"
              class="red"
              [icon]="['fal', 'circle-xmark']"
            ></fa-icon>
            <fa-icon
              [hidden]="errorChart"
              class="green"
              [icon]="['fal', 'circle-check']"
            ></fa-icon>
            {{ 'k002470' | translate }} </small
          ><fa-icon
          class="ml-1 pointer blue2"
          icon="info-circle"
          (click)="viewHintHelp($event)"
          ></fa-icon><br />
          <small>
            <fa-icon
              [hidden]="!errorPasswordRepeat"
              class="red"
              [icon]="['fal', 'circle-xmark']"
            ></fa-icon>
            <fa-icon
              [hidden]="errorPasswordRepeat"
              class="green"
              [icon]="['fal', 'circle-check']"
            ></fa-icon>
            {{ 'k002881' | translate }} </small
          ><br />
        </div>
        <!-- Fin de lo nuevo -->
        <button
          #btnSend
          color="primary"
          type="submit"
          [disabled]="form.invalid"
          class="buttonPortal btn-send-email"
        >
          <span *ngIf="!faSpinner">{{ 'k000018' | translate }}</span
          ><!-- Token: Enviar -->
          <fa-icon [icon]="faSpinner" [spin]="true" *ngIf="faSpinner"></fa-icon>
        </button>
      </form>
    </div>

    <div *ngIf="resetResult">
      <div *ngIf="!isWelcome">
        <p class="title text-center">{{ 'k001960' | translate }}</p>
        <!-- Token: Change password -->
        <p class="content text-center">
          {{ 'k001959' | translate }}
        </p>
        <!-- Token: The password has been changed successfully. Now, you can access your
          personal area. -->
        <p class="text-center mt-30 mb-30">
          <a class="recover-back" routerLink="/login">{{
            'k001963' | translate
          }}</a>
        </p>
        <!-- Token: Go to mainpage -->
      </div>
      <div *ngIf="isWelcome">
        <p class="title text-center">{{ 'k001955' | translate }}</p>
        <!-- Token: Create new password -->
        <p class="content text-center">
          {{ 'k001958' | translate }}
        </p>
        <!-- Token: The password has been generated successfully. Now, you can access your
          personal area. -->
        <p class="text-center mt-30 mb-30">
          <a class="recover-back" routerLink="/login">{{
            'k001963' | translate
          }}</a>
        </p>
        <!-- Token: Go to mainpage -->
      </div>
    </div>
  </mat-card>
</div>
